import React, { useEffect, useState } from "react";
import "./Paginate.css";
import { removePageParam } from "../../../utils/pageParamRemover";

export default function Paginate({ count, value, onPageChange, limit = 12 }) {
  const pageCount = count <= limit ? 1 : Math.ceil(count / limit);
  const [selectedNumber, setSelectedNumber] = useState(1);

  const handlePageClick = (page) => {
    if (page !== selectedNumber) {
      setSelectedNumber(page);

      let cleanURL;
      if (value?.next) {
        cleanURL = removePageParam(value.next);
      } else if (value?.previous) {
        cleanURL = removePageParam(value.previous);
      }

      if (cleanURL) {
        onPageChange({ baseUrl: cleanURL, page });
      }
    }
  };

  const handlePrevClick = () => {
    if (selectedNumber > 1 && value?.previous) {
      setSelectedNumber(selectedNumber - 1);
      onPageChange(value.previous);
    }
  };

  const handleNextClick = () => {
    if (selectedNumber < pageCount && value?.next) {
      setSelectedNumber(selectedNumber + 1);
      onPageChange(value.next);
    }
  };

  const handleSelectChange = (e) => {
    const page = Number(e.target.value);

    if (page !== selectedNumber) {
      setSelectedNumber(page);

      let cleanURL;
      if (value.next) {
        cleanURL = removePageParam(value.next);
      } else if (value.previous) {
        cleanURL = removePageParam(value.previous);
      }

      onPageChange({ baseUrl: cleanURL, page });
    }
  };

  const getPageNumbers = () => {
    const delta = 2;
    let start = Math.max(1, selectedNumber - delta);
    let end = Math.min(pageCount, selectedNumber + delta);

    if (start === 1) {
      end = Math.min(1 + delta * 2, pageCount);
    } else if (end === pageCount) {
      start = Math.max(pageCount - delta * 2, 1);
    }

    let pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  useEffect(() => {
    setSelectedNumber(1);
  }, [count]);

  return (
    <nav aria-label="Page navigation example" style={{ marginLeft: "30px" }}>
      <ul
        style={{ flexDirection: "row-reverse", paddingRight: "30px" }}
        className="pagination justify-content-center pagination-sm mb-4"
      >
        {/* Prev */}
        <li
          onClick={handlePrevClick}
          className={`page-item ${
            selectedNumber === 1 ? "disabled" : "pointer"
          }`}
        >
          <a className="page-link" tabIndex="-1">
            قبل
          </a>
        </li>

        {/* Page numbers */}
        {getPageNumbers().map((page) => (
          <li
            key={page}
            onClick={() => handlePageClick(page)}
            className={`page-item ${
              page === selectedNumber ? "active" : "pointer"
            }`}
          >
            <a className="page-link">{page}</a>
          </li>
        ))}

        {/* Next */}
        <li
          onClick={handleNextClick}
          className={`page-item ${
            selectedNumber === pageCount ? "disabled" : "pointer"
          }`}
        >
          <a className="page-link">بعد</a>
        </li>

        {/* Dropdown */}
        <li className="page-item ml-2 h-[100]">
          <select
            value={selectedNumber}
            onChange={handleSelectChange}
            className="form-select"
            style={{ marginLeft: "10px", height: "30px" }}
          >
            {Array.from({ length: pageCount }, (_, i) => i + 1).map((page) => (
              <option key={page} value={page}>
                {page}
              </option>
            ))}
          </select>
        </li>
      </ul>
    </nav>
  );
}

// import React, { useState } from "react";
// import "./Paginate.css";

// export default function Paginate({ count, onPageChange, limit = 12 }) {
//   const pageCount = count <= limit ? 1 : Math.ceil(count / limit);
//   const [selectedNumber, setSelectedNumber] = useState(1);

//   const goToPage = (page) => {
//     if (page >= 1 && page <= pageCount) {
//       setSelectedNumber(page);
//       onPageChange(page); // ✅ always send page number
//     }
//   };

//   const handlePrevClick = () => {
//     if (selectedNumber > 1) {
//       goToPage(selectedNumber - 1);
//     }
//   };

//   const handleNextClick = () => {
//     if (selectedNumber < pageCount) {
//       goToPage(selectedNumber + 1);
//     }
//   };

//   const handleSelectChange = (e) => {
//     goToPage(Number(e.target.value));
//   };

//   const getPageNumbers = () => {
//     const delta = 2;
//     let start = Math.max(1, selectedNumber - delta);
//     let end = Math.min(pageCount, selectedNumber + delta);

//     if (start === 1) {
//       end = Math.min(1 + delta * 2, pageCount);
//     } else if (end === pageCount) {
//       start = Math.max(pageCount - delta * 2, 1);
//     }

//     let pages = [];
//     for (let i = start; i <= end; i++) {
//       pages.push(i);
//     }
//     return pages;
//   };

//   return (
//     <nav aria-label="Page navigation example" style={{ marginLeft: "30px" }}>
//       <ul
//         style={{ flexDirection: "row-reverse", paddingRight: "30px" }}
//         className="pagination justify-content-center pagination-sm mb-4"
//       >
//         {/* Prev */}
//         <li
//           onClick={handlePrevClick}
//           className={`page-item ${
//             selectedNumber === 1 ? "disabled" : "pointer"
//           }`}
//         >
//           <a className="page-link" tabIndex="-1">
//             قبل
//           </a>
//         </li>

//         {/* Page numbers */}
//         {getPageNumbers().map((page) => (
//           <li
//             key={page}
//             onClick={() => goToPage(page)}
//             className={`page-item ${
//               page === selectedNumber ? "active" : "pointer"
//             }`}
//           >
//             <a className="page-link">{page}</a>
//           </li>
//         ))}

//         {/* Next */}
//         <li
//           onClick={handleNextClick}
//           className={`page-item ${
//             selectedNumber === pageCount ? "disabled" : "pointer"
//           }`}
//         >
//           <a className="page-link">بعد</a>
//         </li>

//         {/* Dropdown */}
//         <li className="page-item ml-2">
//           <select
//             value={selectedNumber}
//             onChange={handleSelectChange}
//             className="form-select"
//             style={{ marginLeft: "10px", height: "30px" }}
//           >
//             {Array.from({ length: pageCount }, (_, i) => i + 1).map((page) => (
//               <option key={page} value={page}>
//                 {page}
//               </option>
//             ))}
//           </select>
//         </li>
//       </ul>
//     </nav>
//   );
// }
